/**
 * Currency formatting utilities
 */

/**
 * Format currency amount with proper locale and currency symbol
 */
export const formatCurrency = (amount, currencyCode = 'EUR', locale = 'de-DE') => {
    if (amount === null || amount === undefined || isNaN(amount)) {
        return `${currencyCode.toUpperCase()} 0.00`;
    }

    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode.toUpperCase(),
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(amount));
    } catch (error) {
        console.warn('Currency formatting error:', error);
        return `${currencyCode.toUpperCase()} ${Number(amount).toFixed(2)}`;
    }
};

/**
 * Format amount without currency symbol
 */
export const formatAmount = (amount, decimals = 2) => {
    if (amount === null || amount === undefined || isNaN(amount)) {
        return '0.00';
    }

    return Number(amount).toFixed(decimals);
};

/**
 * Convert amount to cents (smallest currency unit)
 */
export const toCents = (amount) => {
    return Math.round(Number(amount) * 100);
};

/**
 * Convert cents back to currency amount
 */
export const fromCents = (cents) => {
    return Number(cents) / 100;
};

/**
 * Currency symbols mapping
 */
export const CURRENCY_SYMBOLS = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    CHF: 'CHF',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
};

/**
 * Get currency symbol for a currency code
 */
export const getCurrencySymbol = (currencyCode) => {
    return CURRENCY_SYMBOLS[currencyCode?.toUpperCase()] || currencyCode?.toUpperCase() || 'EUR';
};

const formatters = {
    formatCurrency,
    formatAmount,
    toCents,
    fromCents,
    getCurrencySymbol,
    CURRENCY_SYMBOLS,
};

export default formatters;
